<template>
  <b-card
    no-body
    style="max-width: 40rem;text-align: start;"
  >
    <template #header>
      <h4 class="mb-0">
        <strong>Name: </strong>{{ filteredUserData.user.name }}
      </h4>
    </template>
    <!--  -->
    <b-list-group flush>
      <b-list-group-item v-if="filteredUserData.certificate_category.schema_owne">
        <strong>Branch: <span
          v-for="(branch , index) in filteredUserData.certificate_category.schema_owne"
          :key="index"
        >{{ branch }} <span v-if="index !== filteredUserData.certificate_category.schema_owne.length - 1">,,</span>  </span> </strong>
      </b-list-group-item>
      <b-list-group-item v-if="filteredUserData.user.office_manager ">
        <strong>Manager: {{ filteredUserData.user.office_manager }}</strong>
      </b-list-group-item>
      <b-list-group-item v-if="filteredUserData.user.email">
        <strong>Email: </strong>{{ filteredUserData.user.email }}
      </b-list-group-item>
      <b-list-group-item v-if="userRoles">
        <strong>Role: </strong>{{ userRoles }}
      </b-list-group-item>
      <b-list-group-item>
        <strong>Employment: </strong>
        <b-badge :variant="isExternal ? 'light-warning' : 'light-success'">
          {{ isExternal ? 'External' : 'Internal' }}
        </b-badge>
      </b-list-group-item>
      <b-list-group-item v-if="filteredUserData.user.joined_at">
        <strong>Joined Date: {{ filteredUserData.user.joined_at }}</strong>
      </b-list-group-item>
    </b-list-group>

  </b-card>
</template>

<script>
export default {
  props: {
    filteredUserData: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  computed: {
    userRoles() {
      const roles = this.filteredUserData?.user?.roles
      if (!Array.isArray(roles) || !roles.length) return null
      return roles.map(r => (typeof r === 'string' ? r : r.name)).filter(Boolean).join(', ')
    },
    // is_internal_employee = 0 means external; the flag is what splits the two lists.
    isExternal() {
      const flag = this.filteredUserData?.user?.is_internal_employee
      return flag === 0 || flag === false
    },
  },
}
</script>
